module.exports = __webpack_public_path__ + "media/images/liv__landingImage-5a329e2aac5b4da1fcf7691a774f7574.png";